import ScreenUtils from '../../../../shared/utils/screen';
import styled from 'styled-components';
import withAnimation from '../../../../shared/components/utils/hoc/withAnimation';

const ChannelFilterPressContainer = styled.div<{ focused: boolean }>`
  align-items: center;
  border-radius: ${15 * ScreenUtils.widthRatio}px;
  border: 2px #e0e0e0 solid;
  background: rgba(217, 217, 217, 0.2);
  color: white;
  display: flex;
  flex-direction: row;
  font-family: Roboto;
  font-size: ${32 * ScreenUtils.widthRatio}px;
  height: ${66 * ScreenUtils.widthRatio}px;
  margin-left: ${32 * ScreenUtils.widthRatio}px;
  padding: ${0 * ScreenUtils.widthRatio}px ${20 * ScreenUtils.widthRatio}px;
`;

export default withAnimation(ChannelFilterPressContainer);
